import { Routes } from '@angular/router';
import { TermsAndConditionsComponent } from '../components/terms-and-conditions/terms-and-conditions.component';
import { CompleteUserDataComponent } from 'src/app/components/User/complete-user-data/complete-user-data.component';

export const full: Routes = [
  {
    path: 'error-page',
    loadChildren: () => import('../../pages/error/error.module').then(m => m.ErrorModule),
  },
  // {
  //   path: 'authentication',
  //   loadChildren: () => import('../../pages/authentication/authentication.module').then(m => m.AuthenticationModule),
  // },
  {
    path: 'coming-soon',
    loadChildren: () => import('../../pages/coming-soon/coming-soon.module').then(m => m.ComingSoonModule),
  },
  {
    path: 'pages/helper',
    loadChildren: () => import('../../pages/helper/helper.module').then(m => m.HelperModule),
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  },
  {
    path: 'terms-and-conditions/from-login',
    component: TermsAndConditionsComponent
  },
  {
    path: 'complete-user-data',
    component: CompleteUserDataComponent
  }
];
